import { css, Theme } from 'wiloke-react-core';

export const hiddenContent = css`
  debug: ModalCreate-content;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9;
  overflow: hidden;
`;

export const btnBack = css`
  display: flex;
  align-items: center;
  cursor: pointer;

  margin-right: 10px;
`;

export const container = css`
  debug: ModalCreate-container;
  padding: 20px;
  position: relative;
  height: 100%;
  overflow: hidden;
`;

export const buttonActive = (isActive: boolean) => ({ colors }: Theme) => css`
  border: 1px solid ${isActive ? colors.primary : colors.gray3};
  background-color: rgba(${isActive ? colors.rgbPrimary : colors.light}, ${isActive ? 0.2 : 1});
  border-radius: 6px;
  color: ${colors.gray8};
  min-width: 100px;
  justify-content: flex-start;
  padding: 10px;
`;

export const fakeCheckbox = (isActive: boolean) => ({ colors }: Theme) => css`
  width: 13px;
  height: 13px;
  border: 2px solid ${isActive ? colors.primary : colors.gray3};
  border-radius: 50%;
  background-color: ${colors.light};
`;

export const checkboxGroup = {
  container: css`
    width: 100%;
    display: flex;
  `,
  inner: css`
    display: flex;
    justify-content: space-between;
    width: 100%;
    user-select: none;
    align-items: center;
  `,
  count: css`
    min-width: 22px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};

export const templateContent = {
  container: css`
    padding: 15px;
    width: 100%;
    height: 100%;
  `,
  input: css`
    height: 40px;
    margin-bottom: 10px;
  `,
};

export const collapseHeader = ({ colors }: Theme) => css`
  padding: 6px 0px 10px;
  cursor: pointer;
  font-size: 16px;
  color: ${colors.gray8};
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const collapseContainer = ({ colors }: Theme) => css`
  border-top: unset;
  border-right: unset;
  border-left: unset;
  border-bottom: 1px solid ${colors.gray4};
  box-shadow: none !important;
  border-radius: 0px !important;
  margin-top: 4px;
  margin-bottom: 4px;
`;
